import { ReactChild, ReactFragment, ReactPortal } from 'react';

import Layout from '@/modules/core/components/Layout';

const CestUne = () => (
  <div
    className="relative w-full lg:mt-0 mt-10 mb-20 lg:mb-40 pt-10 lg:pt-20 pb-20 lg:pb-20 px-4 rounded-xl shadow-sm border border-gray-400 bg-no-repeat bg-cover bg-center"
    style={{
      backgroundImage:
        'linear-gradient(rgba(255, 255, 255, 0.90), rgba(255, 255, 255)), url(/media/cestUne.png)',
    }}
  >
    <div className="max-w-3xl mx-auto text-center">
      <img
        className=" mx-auto    rounded-3xl"
        src="/media/cestUne.png"
        alt="C`est une ..."
        width={1080}
        height={80}
      />
    </div>
  </div>
);

export default CestUne;

CestUne.getLayout = function getLayout(
  page: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined
) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
